var map = {
	"./detail.svg": "./src/images/detail.svg",
	"./drag.svg": "./src/images/drag.svg",
	"./hide.svg": "./src/images/hide.svg",
	"./makeprivate.svg": "./src/images/makeprivate.svg",
	"./makepublic.svg": "./src/images/makepublic.svg",
	"./moveToDetails.svg": "./src/images/moveToDetails.svg",
	"./nonCommercial.svg": "./src/images/nonCommercial.svg",
	"./sorting.svg": "./src/images/sorting.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images sync recursive \\.svg$";